export const stripWakeWordsForDisplay = (text) => {
  try {
    if (!text) return text;
    let cleaned = String(text).replace(/\bhi\s+assistant\b[\s,:-]*/i, "");
    cleaned = cleaned.replace(/\s{2,}/g, " ").trim();
    return cleaned;
  } catch (e) {
    return text;
  }
};

